export default __webpack_public_path__ + "static/media/sign-in.aa311620.svg";